/// <amd-module name="VSS/Features/Identities/PersonaDetailsProvider" />
import * as React from "react";
import {
    IdentitiesGetConnectionsResponseModel as IPersonaConnections,
    IIdentity,
    IVssIdentityService,
    VssIdentityServiceName
} from "VSS/Features/Identities/IdentityService";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPageData, IVssPageService } from "VSS/Platform/Page";

import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IdentityCard } from "VSSUI/IdentityCard";
import { IIdentityDetailsProvider, IPersonaProvider } from "VSSUI/Persona";

export class PersonaDetailsProvider implements IPersonaProvider {
    private identityService: IVssIdentityService;
    private pageData: IPageData;

    public constructor(pageContext: IVssPageContext) {
        this.identityService = pageContext.getService<IVssIdentityService>(VssIdentityServiceName);
        this.pageData = pageContext.getService<IVssPageService>("IVssPageService").getData()!;
    }

    public onRequestConnectionInformation = (
        entity: IIdentity,
        getDirectReports?: boolean | undefined
    ): IPersonaConnections | PromiseLike<IPersonaConnections> => {
        return this.identityService.getConnections(entity, getDirectReports);
    };

    public getEntityFromUniqueAttribute = (entityId: string): IIdentity | PromiseLike<IIdentity> => {
        return this.identityService
            .searchIdentitiesAsync(entityId, ["user", "group"], this.pageData.isHosted ? ["ims", "source"] : ["ims", "source", "ad"], "uid")
            .then(x => x[0]);
    };

    public renderIdentityCard = (
        identity: IIdentity | Partial<IdentityRef>,
        detailsProvider: IIdentityDetailsProvider,
        onDismiss: () => void,
        target: HTMLElement
    ): JSX.Element => {
        let identityProps = {};
        if ((identity as IIdentity).entityId) {
            identityProps = {
                identity: identity
            };
        } else {
            const identityRef = identity as Partial<IdentityRef>;
            identityProps = {
                uniqueAttribute: identityRef.id,
                displayName: identityRef.displayName,
                imageUrl: identityRef.imageUrl
            };
        }
        return (
            <IdentityCard
                {...identityProps}
                target={target}
                onDismissCallback={onDismiss}
                onRequestConnectionInformation={detailsProvider.onRequestConnectionInformation}
                getEntityFromUniqueAttribute={detailsProvider.getEntityFromUniqueAttribute}
            />
        );
    };
}
